var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphonecomimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 34,
    viewBox: "0 0 58 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2388L7.03238 33.9998H22.6931L14.2097 12.4346L0 15.2388Z",
    fill: "url(#paint0_linear_20_310)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9542 33.9266L17.2612 11.789L25.66 9.70738L35.0216 7.40479L44.0133 33.9222L25.9542 33.9266Z",
    fill: "url(#paint1_linear_20_310)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2548 11.7894L7.03271 33.9999H22.6934L35.0464 7.41406L17.2548 11.7894Z",
    fill: "#FFD100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9334 6.03933L25.9541 33.9268H44.0065L57.9999 0L38.9334 6.03933Z",
    fill: "#E20613"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0304 7.44472L35.0237 7.42041L17.2544 11.7891L24.4762 30.1613L35.0304 7.44472Z",
    fill: "url(#paint2_linear_20_310)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03271 33.9999H22.6934L15.476 15.6543L7.03271 33.9999Z",
    fill: "url(#paint3_linear_20_310)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9541 33.9265H44.0087L36.399 11.4751L25.9541 33.9265Z",
    fill: "url(#paint4_linear_20_310)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_310",
    x1: 11.3454,
    y1: 33.9998,
    x2: 11.3454,
    y2: 12.4368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_310",
    x1: 30.6306,
    y1: 33.9266,
    x2: 30.6306,
    y2: 7.40479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_310",
    x1: 26.1435,
    y1: 30.1613,
    x2: 26.1435,
    y2: 7.42041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_310",
    x1: 14.8631,
    y1: 15.6543,
    x2: 14.8631,
    y2: 33.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_310",
    x1: 25.9541,
    y1: 22.703,
    x2: 44.0087,
    y2: 22.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphonecomimg);
export default __webpack_public_path__ + "static/media/iphonecomimg.76d0b79374092597d2e275996d82eada.svg";
export { ForwardRef as ReactComponent };